import { lazy, Suspense, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import "aos/dist/aos.css";
import "./assets/vendor/bootstrap/css/bootstrap.min.css";
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./assets/css/main.css";
import "./App.css";

const Home = lazy(() => import("./component/Home"));
const ProjectDetail = lazy(() => import("./component/ProjectDetail"));
const ChatBot = lazy(() => import("./component/ChatBot"));
const ServicePage = lazy(() => import("./component/ServicePage"));
const PrivacyPage = lazy(() => import("./component/PrivacyPage"));
const Analytics = lazy(() => import("./component/Analytics"));

function PageLoader() {
  return <div className="page-loader" role="status" aria-live="polite">Loading…</div>;
}

function App() {
  const [showChat, setShowChat] = useState(false);

  useEffect(() => {
    const revealChat = () => setShowChat(true);
    const idleId = "requestIdleCallback" in window
      ? window.requestIdleCallback(revealChat, { timeout: 3000 })
      : window.setTimeout(revealChat, 1800);

    return () => {
      if ("cancelIdleCallback" in window) window.cancelIdleCallback(idleId);
      else window.clearTimeout(idleId);
    };
  }, []);

  return (
    <>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/hire-dotnet-developer" element={<ServicePage pageKey="hire-dotnet-developer" />} />
          <Route path="/aspnet-core-development-services" element={<ServicePage pageKey="aspnet-core-development-services" />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<ProjectDetail invalidRoute />} />
        </Routes>
        <Analytics />
        {showChat && <ChatBot />}
      </Suspense>
    </>
  );
}

export default App;
